// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.back-button{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
}
.back-button:hover{
    background-color: #e7e7e7;
}

.document_card{
    border-radius: 20px;
    border: 1px solid rgb(27, 133, 255);
    padding: 1rem;
}

.document_card:hover{
    background-color: #eef7ff;
}
.plan-nego{
    padding: 10px 20px; 
    /* margin-bottom: 40px; */
    
}
.plan-card{
    height: 25rem;
    width: 18rem;
    border-radius: 20px;
    /* margin-top: 3rem; */
    /* margin-left: 20px; */
    padding: 0.5rem 0;
    border: 1px solid #6666666c;
}
.plan-card h6{
    font-size: 12px;
}

.plan-card-box{
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/Components/Profile/Profile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,yBAAyB;;AAE7B;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".back-button{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 50%;\n}\n.back-button:hover{\n    background-color: #e7e7e7;\n}\n\n.document_card{\n    border-radius: 20px;\n    border: 1px solid rgb(27, 133, 255);\n    padding: 1rem;\n}\n\n.document_card:hover{\n    background-color: #eef7ff;\n}\n.plan-nego{\n    padding: 10px 20px; \n    /* margin-bottom: 40px; */\n    \n}\n.plan-card{\n    height: 25rem;\n    width: 18rem;\n    border-radius: 20px;\n    /* margin-top: 3rem; */\n    /* margin-left: 20px; */\n    padding: 0.5rem 0;\n    border: 1px solid #6666666c;\n}\n.plan-card h6{\n    font-size: 12px;\n}\n\n.plan-card-box{\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
